module.exports = __webpack_public_path__ + "img/水杯1.83ee96e8.png";